export const DEFAULT_ORDER_BY_VALUE = "new_first";